/** Shared responsive positioning for Radix Dialog / AlertDialog (mobile keyboard-safe sheet). */

const KEYBOARD_SCROLL_CONTAINER_ATTR = "data-keyboard-scroll";
const KEYBOARD_SCROLL_CONTAINER_SELECTOR =
  "[data-pro-scroll], [data-drawer-scroll], [data-keyboard-scroll]";
const KEYBOARD_OVERLAY_ATTR = "data-keyboard-overlay";

const OVERLAY_MOBILE_KEYBOARD_SHEET_CLASS =
  "max-md:top-auto max-md:bottom-[env(safe-area-inset-bottom,0px)] max-md:translate-y-0 max-md:rounded-t-xl max-md:rounded-b-none max-md:max-h-[calc(var(--visual-vh,100vh)*0.92-env(safe-area-inset-bottom,0px))]";

const OVERLAY_DESKTOP_CENTER_CLASS =
  "md:top-[calc(var(--visual-vh,100vh)/2)] md:-translate-y-1/2 md:max-h-[calc(var(--visual-vh,100vh)-40px)]";

const OVERLAY_SCROLLABLE_BODY_CLASS = "overflow-y-auto overscroll-y-contain";

const MOBILE_VISUAL_VIEWPORT_SHELL_CLASS =
  "fixed inset-x-0 top-[var(--visual-offset-top,0px)] h-[var(--visual-vh,100vh)]";

export {
  KEYBOARD_OVERLAY_ATTR,
  KEYBOARD_SCROLL_CONTAINER_ATTR,
  KEYBOARD_SCROLL_CONTAINER_SELECTOR,
  MOBILE_VISUAL_VIEWPORT_SHELL_CLASS,
  OVERLAY_DESKTOP_CENTER_CLASS,
  OVERLAY_MOBILE_KEYBOARD_SHEET_CLASS,
  OVERLAY_SCROLLABLE_BODY_CLASS,
};
